// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';
import { brokeredPreviewStorage } from './previewAuthStorage';

export const SUPABASE_URL = "https://rvxezvqujgxpknzuzafr.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InJ2eGV6dnF1amd4cGtuenV6YWZyIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTY4MDk1OTYsImV4cCI6MjA3MjM4NTU5Nn0.-UJwfGmTRc-tLYvLHu6U56CubEl2R1lSaGg7IV-z_pA";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: brokeredPreviewStorage(),
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  }
});